import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressComponent } from 'src/app/shared/components/address/address.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactComponent } from 'src/app/shared/components/contact/contact.component';
import { FinanceComponent } from 'src/app/shared/components/finance/finance.component';
import { SysLogsComponent } from 'src/app/shared/components/sys-logs/sys-logs.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HttpClientModule } from '@angular/common/http';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxPaginationModule } from 'ngx-pagination';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { Select2Module } from 'ng-select2-component';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SearchEmpComponent } from 'src/app/shared/components/search-emp/search-emp.component';
import { UrlPipePipe } from 'src/app/service/pipes/url-pipe/url-pipe.pipe';
import { ThumbnailPipePipe } from 'src/app/service/pipes/thumbnail/thumbnail-pipe.pipe';
import { MatChipsModule } from '@angular/material/chips';
import { QueryComponent } from 'src/app/shared/components/query/query.component';
import { FilterPipe } from 'src/app/service/pipes/filter-pipe/filter.pipe';
import { CourseModalComponent } from 'src/app/shared/components/course-modal/course-modal.component';
import { MedicalModalComponent } from 'src/app/shared/components/medical-modal/medical-modal.component';
import { PassportModalComponent } from 'src/app/shared/components/passport-modal/passport-modal.component';
import { VisaModalComponent } from 'src/app/shared/components/visa-modal/visa-modal.component';
import { EmpAttendanceComponent } from 'src/app/shared/components/emp-attendance/emp-attendance.component';
import { PortalModule } from '@angular/cdk/portal';
import { ApplyLeaveComponent } from '../leave/apply-leave/apply-leave.component';
import { ReadMoreComponent } from 'src/app/shared/components/read-more/read-more.component';
import { AddIssueComponent } from '../time-sheets/time-category/components/add-issue/add-issue.component';
import { DropZoneDirective } from 'src/app/service/directives/dropZone/drop-zone.directive';
import { MatStepperModule } from '@angular/material/stepper';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';

@NgModule({
  declarations: [
    AddressComponent,
    EmpAttendanceComponent,
    ContactComponent,
    FinanceComponent,
    SysLogsComponent,
    SearchEmpComponent,
    UrlPipePipe,
    ThumbnailPipePipe,
    FilterPipe,
    QueryComponent,
    CourseModalComponent,
    MedicalModalComponent,
    PassportModalComponent,
    VisaModalComponent,
    ApplyLeaveComponent,
    ReadMoreComponent,
    AddIssueComponent,
    DropZoneDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatButtonModule,
    InfiniteScrollModule,
    NgxPaginationModule,
    MatTooltipModule,
    UiSwitchModule,
    Select2Module,
    MatChipsModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatSelectModule
  ],
  exports: [
    AddressComponent,
    EmpAttendanceComponent,
    ContactComponent,
    FinanceComponent,
    SysLogsComponent,
    TranslateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    InfiniteScrollModule,
    NgxPaginationModule,
    UiSwitchModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    SearchEmpComponent,
    UrlPipePipe,
    ThumbnailPipePipe,
    FilterPipe,
    MatChipsModule,
    QueryComponent,
    CourseModalComponent,
    MedicalModalComponent,
    PassportModalComponent,
    VisaModalComponent,
    PortalModule,
    ApplyLeaveComponent,
    ReadMoreComponent,
    AddIssueComponent,
    MatStepperModule,
    MatSlideToggleModule,
    MatSelectModule
  ],
})
export class SharedModule {}
